import { render, staticRenderFns } from "./CrashDetail.vue?vue&type=template&id=9d264d4c"
import script from "./CrashDetail.vue?vue&type=script&lang=js"
export * from "./CrashDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports